export default __webpack_public_path__ + "static/tub_b.7038d67126bf94a38f8631b28383b665.svg";